// src/utils/useToast.js
import Swal from 'sweetalert2';

export const useToastHook = () => {
  const showToast = (message, icon = 'info', timer = 3000) => {
    Swal.fire({
      text: message,
      icon,
      toast: true,
      timer,
      position: 'top-right',
      timerProgressBar: true,
      showConfirmButton: false,
    });
  };

  return {
    success: (message) => showToast(message, 'success'),
    error: (message) => showToast(message, 'error'),
    info: (message) => showToast(message, 'info'),
    warning: (message) => showToast(message, 'warning'),
  };
};